import { motion } from "framer-motion";
import { ShieldCheck, BadgeCheck, Lock, MessageSquare } from "lucide-react";

const POINTS = [
    {
        icon: BadgeCheck,
        title: "Profils vérifiés",
        desc: "Profil et photo vérifiés afin de renforcer la confiance entre voyageurs. Vous savez avec qui vous partagez votre trajet.",
    },
    {
        icon: Lock,
        title: "Sans intermédiaire financier",
        desc: "Coway reste une plateforme simple et transparente. Les voyageurs s'organisent librement entre eux pour partager les frais du trajet.",
    },
    {
        icon: MessageSquare,
        title: "Chat avant le trajet",
        desc: "Discutez en messagerie chiffrée avant de monter à bord. Pas besoin de partager votre numéro.",
    },
    {
        icon: ShieldCheck,
        title: "Voyagez sereinement",
        desc: "Coway favorise des échanges simples et une meilleure organisation entre voyageurs avant le trajet.",
    },
];

export default function Security() {
    return (
        <section
            id="security"
            data-testid="security-section"
            className="relative py-24 lg:py-32 overflow-hidden"
        >
            <div className="absolute inset-0 -z-10 bg-surface-soft">
                <div className="absolute inset-0 bg-[radial-gradient(50%_50%_at_20%_30%,rgba(81,199,173,0.08),transparent_70%)]" />
            </div>

            <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
                <div className="lg:col-span-5 lg:sticky lg:top-32">
                    <p className="text-xs text-coway uppercase tracking-[0.3em] font-semibold mb-5">
                        Sécurité
                    </p>
                    <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[0.95] text-slate-900">
                        Pensé pour la
                        <br />
                        confiance.
                    </h2>
                    <p className="mt-6 text-lg text-slate-600 max-w-md">
                        Coway met la confiance et la sécurité au cœur de
                        chaque trajet. Profils vérifiés, messagerie privée et
                        échanges simplifiés — tout est pensé pour vous
                        permettre de voyager sereinement.
                    </p>
                    <div className="mt-8 inline-flex items-center gap-3 px-4 py-2.5 rounded-full bg-white border border-slate-200 shadow-sm">
                        <span className="w-2 h-2 rounded-full bg-coway animate-pulse" />
                        <span className="text-sm font-medium text-slate-900">
                            Données hébergées en Europe (RGPD)
                        </span>
                    </div>
                </div>

                <div className="lg:col-span-7 grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-5">
                    {POINTS.map((p, i) => (
                        <motion.div
                            key={p.title}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-80px" }}
                            transition={{
                                duration: 0.6,
                                delay: i * 0.08,
                                ease: [0.16, 1, 0.3, 1],
                            }}
                            className="relative p-7 rounded-3xl bg-white border border-slate-200 hover:border-coway/40 transition-colors card-elevated group"
                            data-testid={`security-card-${i + 1}`}
                        >
                            <span className="inline-flex w-12 h-12 rounded-2xl bg-coway-soft border border-coway/15 items-center justify-center mb-6">
                                <p.icon
                                    className="w-5 h-5 text-coway"
                                    strokeWidth={1.8}
                                />
                            </span>
                            <h3 className="font-display text-xl font-bold tracking-tight text-slate-900">
                                {p.title}
                            </h3>
                            <p className="mt-2 text-sm text-slate-500 leading-relaxed">
                                {p.desc}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
